<template>
  <div>
    <v-tabs v-model="tabsIndex">
      <v-tab
        v-for="(tab, index) in RecordViewerTabs"
        :key="index"
        @click.self="switchTab(tab, RecordViewerTabs.indexOf(RecordItem))"
        show-arrows
      >
        <v-icon
          @click.self="switchTab(tab, RecordViewerTabs.indexOf(RecordItem))"
        >
          {{ tabType(tab.type) }}
        </v-icon>
        <div
          class="mx-5"
          @click.self="switchTab(tab, RecordViewerTabs.indexOf(RecordItem))"
        >
          <v-row
            justify="center"
            @click.self="switchTab(tab, RecordViewerTabs.indexOf(RecordItem))"
          >
            {{ tab.name }}
          </v-row>
          <v-row
            v-if="tab.recordName !== tab.name"
            justify="center"
            @click.self="switchTab(tab, RecordViewerTabs.indexOf(RecordItem))"
          >
            ({{ tab.recordName }})
          </v-row>
        </div>
        <v-icon class="ml-2" small @click.stop="closeSingleTab(tab)">
          mdi-close-circle
        </v-icon>
      </v-tab>
    </v-tabs>
    <UnsavedChangesIntercept
      :showUnsavedChangesInterceptor="showUnsavedChangesInterceptor"
      :editedoldtab="editedoldtab"
      :uneditedoldtab="uneditedtab"
      :closedTab="closedTab"
      v-on:saveChanges="saveChanges($event)"
      v-on:discardChanges="discardChanges($event)"
      v-on:discardChangesAndCloseTab="discardChangesAndCloseTab($event)"
    />
  </div>
</template>

<script>
import { mdiCloseCircle } from "@mdi/js";
import { mapState, mapActions, mapGetters } from "vuex";
import UnsavedChangesIntercept from "./unsaved-changes/Intercept";
export default {
  components: {
    UnsavedChangesIntercept
  },
  computed: {
    ...mapGetters({
      RecordItem: "getRecordItem",
      FullRecord: "getRecord"
    }),
    ...mapState({
      RecordViewerTabs: state => state.records.tabs,
      UneditedRecordItem: state => state.records.uneditedCurrentRecord,
      showUnsavedChangesintercept: state =>
        state.records.showUnsavedChangesIntercept,
      NavtoTab: state => state.records.navigatingtotab
    }),
    tabsIndex: {
      get() {
        return this.$store.state.records.activeTabIndex;
      },
      set(value) {
        this.$store.commit("UPDATE_ACTIVE_TAB", value);
      }
    }
  },
  watch: {
    RecordViewerTabs: function() {
      // this.$store.commit('updateActiveTab', this.RecordViewerTabs.length - 1);
      // this.uneditedtab = JSON.parse(
      //   JSON.stringify(this.RecordViewerTabs[this.tabs])
      // );
      // this.$emit('switchTabs');
    },
    showUnsavedChangesIntercept: function() {
      this.navigatingtotab = this.NavtoTab;
      this.editedoldtab = this.RecordViewerTabs[this.tabs];
      this.showUnsavedChangesInterceptor = this.showUnsavedChangesintercept;
    }
  },

  data() {
    return {
      mdiCloseCircle,
      //unsaved changes interceptor
      navigatingtotab: {},
      uneditedtab: {},
      editedoldtab: {},
      closedTab: false,
      showUnsavedChangesInterceptor: false
    };
  },
  methods: {
    ...mapActions([
      "switchToTab",
      "setCurrentlySelectedRecordItem",
      "closeTab",
      "switchToChartTab",
      "closeChartView",
      "getRecordNameById"
    ]),
    saveChanges(closedTab) {
      if (closedTab) {
        this.showUnsavedChangesInterceptor = false;
        return this.$emit("saveChangesAndCloseTab", closedTab);
      }

      this.$emit("saveChanges", this.navigatingtotab);
      this.showUnsavedChangesInterceptor = false;
    },
    discardChanges(oldtabpackage) {
      this.$emit("discardChanges", oldtabpackage);
      this.switchToTab(this.navigatingtotab);
      this.showUnsavedChangesInterceptor = false;
    },
    discardChangesAndCloseTab(closedTab) {
      this.$emit("discardChangesAndCloseTab", closedTab);
      this.closedTab = false;
      this.showUnsavedChangesInterceptor = false;
      this.closeTab(closedTab);
    },
    switchTab(tab, oldtab) {
      //check for unsaved changes
      if (
        JSON.stringify(this.UneditedRecordItem) !=
          JSON.stringify(this.FullRecord) &&
        JSON.stringify(this.UneditedRecordItem) != JSON.stringify({})
      ) {
        this.navigatingtotab = tab;
        this.editedoldtab = this.RecordViewerTabs[this.tabs];
        return (this.showUnsavedChangesInterceptor = true);
      }
      this.$emit("switchTabs");
      this.uneditedtab = JSON.parse(JSON.stringify(tab));

      this.switchToTab(tab);
    },
    closeSingleTab(tab) {
      if (
        JSON.stringify(this.UneditedRecordItem) !=
          JSON.stringify(this.FullRecord) &&
        JSON.stringify(this.UneditedRecordItem) != JSON.stringify({})
      ) {
        this.closedTab = tab;
        return (this.showUnsavedChangesInterceptor = true);
      }
      this.closeTab(tab);
    },
    getRecordName(recordId) {
      let response;
      this.getRecordNameById(recordId).then(res => (response = res));
    },
    tabType: function(type) {
      switch (type) {
        case "graph":
          return "mdi-chart-line";
        case "group":
          // return 'mdi-table-account';
          return "mdi-select-group";
        case "event":
          return "mdi-clipboard-edit-outline";
        case "analysis":
          return "mdi-family-tree";
        default:
          return "mdi-clipboard-outline";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.v-tab {
  text-transform: none;
  align-items: center;
}
</style>
